import { useTranslation } from "react-i18next";

import { useLoginDataStore } from "@/stores/useLoginDataStore";
import { useTokenRefreshLoadingStore } from "@/stores/useTokenRefreshLoadingStore";
import { useTokenStore } from "@/stores/useTokenStore";
import { useUserDataStore } from "@/stores/useUserDataStore";

import { ALERT_STATUS } from "../../context/alert/types";
import useResponse from "../../shared/hooks/useResponse";
import axios from "../axios";
import { ApiResources } from "../resources";

const useRefreshToken = () => {
  const { handleResponse } = useResponse();
  const { t } = useTranslation();

  const setIsTokenRefreshLoading = useTokenRefreshLoadingStore(
    (state) => state.setIsTokenRefreshLoading
  );
  const setUser = useUserDataStore((state) => state.setUserData);
  const setIs2FaVerification = useLoginDataStore(
    (state) => state.setIs2FaVerification
  );

  const refreshToken = async () => {
    try {
      setIsTokenRefreshLoading(true);

      // Get fresh token from store
      const currentTokenInfo = useTokenStore.getState().tokenInfo;

      const resp = await axios.post(ApiResources.RefreshToken, {
        accessToken: currentTokenInfo?.token,
        refreshToken: currentTokenInfo?.refreshToken
      });

      if (resp) {
        useTokenStore.getState().setTokenInfo(resp.data);
      }

      return resp?.data;
    } catch (error: any) {
      useTokenStore.getState().setTokenInfo(null);
      setUser(null);
      setIs2FaVerification(false);

      const errorMessage =
        typeof error.response?.data?.message === "string"
          ? error.response.data.message
          : t("General##unauthorized");
      handleResponse(ALERT_STATUS.Critical, errorMessage);
    } finally {
      setIsTokenRefreshLoading(false);
    }
  };

  return refreshToken;
};

export default useRefreshToken;
